/**
 * Shared user store module to avoid circular dependencies
 * This module should not import from runtime.ts or observability.ts
 */
import { reactive } from "vue"

export const store = reactive<{
  user?: {
    id: string
    name: {
      firstName: string
      lastName: string
    }
  }
}>({
  user: undefined
})
